import { store } from "./state.js";

const SHADOW = `
<style>
:host {
  display: block;
}

.container {
  position: relative;
  padding: 0 4px;
  background: #EEE;
}

textarea {
  width: 100%;
  resize: none;
  field-sizing: content;
  border: none;
  background: transparent;
  padding: 12px 0;
  overflow-x: auto;
  white-space: nowrap;

  &::selection {
    background-color: transparent;
  }

  &:focus {
    border: none;
    outline: none;
  }
}

button.copy {
  position: absolute;
  top: 0;
  right: 0;
  background: #FFFC;
  padding: 4px 8px;
  border-radius: 0 0 0 12px;
  border: none;
  text-transform: uppercase;

  &:hover, &:focus {
    background: white;
  }
}

.toast {
  pointer-events: none;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--dark-gray);
  color: white;
  border: 1px solid white;
  padding: 8px;
  opacity: 1;
  transition: opacity .3s linear;

  &[hidden] {
    opacity: 0;
    transition-duration: 1s;
  }
}
</style>
<div class="container">
  <textarea readonly tabindex=0></textarea>
  <div class="toast" hidden><slot name="toast">Copy successful!</slot></div>
  <button class="copy">
    <slot name="copy">Copy to clipboard</slot>
  </button>
</div>
`;

export class ShareText extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = SHADOW;
    this.output = this.shadowRoot.querySelector("textarea");
    this.toast = this.shadowRoot.querySelector(".toast");
    store.addEventListener("update", this);
    this.output.addEventListener("click", this);
    this.copyButton = this.shadowRoot.querySelector("button.copy");
    this.copyButton.addEventListener("click", this);
  }

  handleEvent(e) {
    switch (e.type) {
      case "update":
        let text = "%URL%";
        let template = this.querySelector("template");
        if (template) {
          text = template.innerHTML.trim();
        }
        let content = text.replace("%URL%", window.location);
        this.output.value = content;
      break;

      case "click":
        this.output.selectionStart = 0;
        this.output.selectionEnd = this.output.value.length;
        document.execCommand("copy");
        this.toast.removeAttribute("hidden");
        setTimeout(_ => this.toast.setAttribute("hidden", true), 3000);
      break;
    }
  }
}

window.customElements.define("share-text", ShareText);

if ("share" in navigator) {
  document.body.classList.add("navigator-share");
}

export class ShareNative extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this);
  }

  handleEvent() {
    let url = window.location.href;
    console.log(url, document.title);
    navigator.share({
      url,
      title: document.title,
      text: document.title,
    });
  }
}

window.customElements.define("share-native", ShareNative)